import type { UserRequiresPhoneVerification } from './user-requires-phone-verification.model';

export interface GenerateUserRequiresPhoneVerificationOptions {
  readonly userId: string;
  readonly userRequiresPhoneVerification: boolean;
  readonly latestProjectIdWithPaidUpgrade?: number;
}

export function generateUserRequiresPhoneVerificationObject({
  userId,
  userRequiresPhoneVerification,
  latestProjectIdWithPaidUpgrade,
}: GenerateUserRequiresPhoneVerificationOptions): UserRequiresPhoneVerification {
  return {
    id: userId,
    userRequiresPhoneVerification,
    ...(latestProjectIdWithPaidUpgrade !== undefined
      ? { latestProjectIdWithPaidUpgrade }
      : {}),
  };
}
